import request from '@/utils/request'

export async function getLoginLog(data) {
  return request({
    url: '/log/login/page',
    method: 'post',
    data,
  })
}
export async function getOperationLog(data) {
  return request({
    url: '/log/user/page',
    method: 'post',
    data,
  })
}